export const planHeight = () => {
  // setTimeout(() => { 
  //   console.log('执行了')
  //   const searchHeight = document.getElementsByClassName("search")[0]
  //   if (searchHeight) {
  //     const _searchHeight = searchHeight.clientHeight

  //     const stockHeight = document.getElementsByClassName("stockDiv")[0]
  //     const _stockHeight = stockHeight.clientHeight
    
  //     const contensHeight = document.getElementsByClassName("Stock-Contents")
  //     var arr = Array.from(contensHeight)
  //     arr.forEach(element => {
  //       element.style.height = (_stockHeight - _searchHeight) + 'px'
  //     }); 
  //   }               
  // },1000)
}